/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _scrollViewport = __webpack_require__(1);
	
	var _scrollViewport2 = _interopRequireDefault(_scrollViewport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var caseLength = window.caseLenght || 0;
	var one = {};
	var clickadd;
	
	(0, _scrollViewport2["default"])('.screen', function ($screen) {
	  $screen.addClass('active').removeClass('disabled-animated');
	}, {
	  delayDistance: 200,
	  onLeave: function onLeave($screen) {
	    $screen.removeClass('active');
	  }
	});
	
	var clear = $("#clear");
	var head = $(".menu-item-head");
	var clicktap = $(".clicktap");
	var contentbody = $(".content-body");
	var title = $("title");
	var clickweixin = $(".jiathis_button_weixin");
	$(document).ready(function () {
	
	  if (clear.attr("name") != "") {
	    $("#body" + clear.attr("name")).css("display", "block");
	    $("." + clear.attr("name")).css("background-color", "#cb503c");
	  } else {
	    $(".i0").css("display", "block");
	    $("#0").css("background-color", "#cb503c");
	  }
	  if (head.length % 5 == 1) {
	    head.eq(head.length - 1).css("width", "1000px");
	  }
	});
	
	clicktap.click(function () {
	  // alert(user)
	  title.text("星耀蓝图-招聘-" + $(this).text());
	  clicktap.css("background-color", "#ea6c4e");
	  $(this).css("background-color", "#cb503c");
	  contentbody.hide().eq($(this).attr("id")).show();
	});
	
	clickweixin.click(function () {
	  var myWindow = window.open('', '扫码分享', 'width=600,height=450,top=100, left=500');
	  myWindow.document.write("<title>扫码分享</title>");
	  myWindow.document.write("<p style='font-size:35px;text-align: center'>手机微信扫码，点击右上角分享！</p>");
	  myWindow.document.write("<img style='margin-left:170px' src='/sendhref?text=" + window.location.href + "'/>");
	  myWindow.focus();
	  myWindow.document.close();
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInViewport = isInViewport;
	exports["default"] = scrollViewport;
	/**
	 * @requires jQuery
	 * @author Tianyz
	 */
	var $window = $(window);
	
	/**
	 * 判断元素是否进入可见区域
	 * 不用兼容 IE8 的话可以用 getBoundingClientRect 实现
	 * @param  {object}  $elm           dom 对象
	 * @param  {number}  delayDistance  延长距离
	 * @return {Boolean}
	 */
	function isInViewport($elm) {
	  var delayDistance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var elmTop = $elm.offset().top;
	  var elmBottom = elmTop + $elm.outerHeight();
	  var screenTop = $window.scrollTop();
	  var screenBottom = screenTop + $window.height();
	
	  if (screenBottom > elmTop + delayDistance && screenTop < elmBottom) {
	    return true;
	  }
	
	  return false;
	}
	
	/**
	 * 监听元素进入可视区域的状态
	 * @param  {string}   elmSelector 元素选择器
	 * @param  {function} onEnter     进入可视区域的回调 参数为 jQuery 对象
	 * @param  {hash} options       {
	 *                                delayDistance {number} 延长的触发距离，设为负数则为提前触发的距离
	 *                                onLeave       {function} 离开可视区域的操作
	 *                              }
	 * @return {null}
	 */
	function scrollViewport(elmSelector, onEnter, options) {
	  var defaultOptions = {
	    delayDistance: 0,
	    onLeave: null
	  };
	  var $targets = $(elmSelector);
	
	  // options = Object.assign(defaultOptions, options);
	  // 都是为了兼容 ie8
	  $.extend(defaultOptions, options);
	  options = defaultOptions;
	
	  function activeInViewport() {
	    // TODO: _.debounce
	    $targets.each(function () {
	      var $elm = $(this);
	
	      if (!isInViewport($elm, options.delayDistance)) {
	        if (typeof options.onLeave === 'function') {
	          options.onLeave($elm);
	        }
	      } else {
	        onEnter($elm);
	      }
	    });
	  }
	
	  activeInViewport();
	
	  $window.on('scroll', activeInViewport);
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// joinUsInfo.js